"use client";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";

// ✅ Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

//
// ✅ STORE USER (same)
//
export const storeAuthData = (responseData) => {
  const { user } = responseData;

  if (user) {
    Cookies.set("user", JSON.stringify(user));
    Cookies.set("userRole", user.role || "user");
    Cookies.set("userId", user.userId);
    Cookies.set("userName", user.fullname);
  }
};

//
// 🔐 REQUEST INTERCEPTOR (🔥 MAIN FIX)
//
api.interceptors.request.use(
  (config) => {
    try {
      
      // ✅ Get adminUser from localStorage
      const adminData = localStorage.getItem("adminUser");

      console.log("adminData", adminData)

      if (adminData) {
        const parsed = JSON.parse(adminData);

        console.log("parsed", parsed)

        // ✅ Attach token if exists
        if (parsed?.token) {
          config.headers.Authorization = `Bearer ${parsed.token}`;
        }

      }

    } catch (err) {
      console.log("Token parse error:", err);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

//
// 🚨 RESPONSE INTERCEPTOR
//
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {

      // ❌ Clear cookies
      Cookies.remove("user");
      Cookies.remove("userRole");
      Cookies.remove("userId");
      Cookies.remove("userName");

      // ❌ Clear admin localStorage
      localStorage.removeItem("adminUser");

      toast.error("Session expired. Please log in again.");

      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    }

    return Promise.reject(error);
  }
);

export default api;